export const ErrorIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="10" cy="10" r="9.5" stroke="white" />
      <path d="M6 6L14 14" stroke="white" />
      <path d="M6 14L14 6" stroke="white" />
    </svg>
  );
};
